

export class AlertSpecificationOutput implements IAlertSpecificationOutput {
    /** The auto-generated id of the alert specification */
    alert_specification_id!: number;

    constructor(data?: IAlertSpecificationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_specification_id = _data["alert_specification_id"];
        }
    }

    static fromJS(data: any): AlertSpecificationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_specification_id"] = this.alert_specification_id;
        return data; 
    }
}

export interface IAlertSpecificationOutput {
    /** The auto-generated id of the alert specification */
    alert_specification_id: number;
}

